function deriveFromBusinessUrl(functionName: string): string {
  const businessUrl = import.meta.env.VITE_BUSINESS_API_URL as
    | string
    | undefined;
  if (!businessUrl) {
    throw new Error(`VITE_BUSINESS_API_URL must be set to derive ${functionName} URL`);
  }
  return businessUrl.replace(/\/$/, "").replace(/apiBusiness$/, functionName);
}

/**
 * Resolve the URL for the streaming Intelligence chat endpoint (`apiChat`).
 *
 * `apiChat` is deployed as a separate Firebase Function from `apiBusiness`
 * because the latter buffers responses through `fastify.inject()`. Both
 * functions live in the same project + region, so by default we derive the
 * chat URL from {@link import.meta.env.VITE_BUSINESS_API_URL} by swapping the
 * last path segment (`apiBusiness` → `apiChat`).
 *
 * For local dev / overrides, set `VITE_CHAT_API_URL` explicitly.
 */
export function getChatUrl(): string {
  const explicit = import.meta.env.VITE_CHAT_API_URL as string | undefined;
  if (explicit) return explicit.replace(/\/$/, "");
  return deriveFromBusinessUrl("apiChat");
}

/**
 * Resolve the URL for the MCP HTTP endpoint (`apiMcp`).
 *
 * Follows the same pattern as {@link getChatUrl}: swap `apiBusiness` →
 * `apiMcp` from `VITE_BUSINESS_API_URL`, or use `VITE_MCP_API_URL` directly
 * for local dev / overrides.
 */
export function getMcpUrl(): string {
  const explicit = import.meta.env.VITE_MCP_API_URL as string | undefined;
  if (explicit) return explicit.replace(/\/$/, "");
  return deriveFromBusinessUrl("apiMcp");
}
